import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useAppSelector } from '../../store/hooks';

interface MessageBubbleProps {
  message: string;
  isBot: boolean;
  timestamp?: string;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isBot, timestamp }) => {
  const { theme } = useAppSelector((state) => state.ui);

  const textColor = isBot
    ? theme === 'dark'
      ? 'text-white'
      : 'text-gray-900'
    : 'text-white';

  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'} mb-3 sm:mb-4`}>
      <div
        className={`max-w-[85%] sm:max-w-[80%] rounded-2xl px-3 py-2 sm:px-4 sm:py-2.5 ${
          isBot
            ? theme === 'dark'
              ? 'bg-gray-700 text-white'
              : 'bg-gray-100 text-gray-900'
            : theme === 'dark'
            ? 'bg-blue-600 text-white'
            : 'bg-blue-500 text-white'
        }`}
      >
        {isBot ? (
          <div className={`text-xs sm:text-sm whitespace-pre-wrap break-words ${textColor}`}>
            <ReactMarkdown
              components={{
                p: ({ children }) => <p className="mb-1 last:mb-0">{children}</p>,
                strong: ({ children }) => (
                  <strong className="font-semibold">{children}</strong>
                ),
                em: ({ children }) => <em className="italic">{children}</em>,
                ul: ({ children }) => (
                  <ul className="list-disc list-inside my-1 space-y-0.5 sm:space-y-1">{children}</ul>
                ),
                ol: ({ children }) => (
                  <ol className="list-decimal list-inside my-1 space-y-0.5 sm:space-y-1">{children}</ol>
                ),
                li: ({ children }) => <li className="ml-1 sm:ml-2">{children}</li>,
                code: ({ children }) => (
                  <code
                    className={`px-1 py-0.5 rounded text-[10px] sm:text-xs ${
                      theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'
                    }`}
                  >
                    {children}
                  </code>
                ),
                pre: ({ children }) => (
                  <pre
                    className={`p-1.5 sm:p-2 rounded my-1 overflow-x-auto text-[10px] sm:text-xs ${
                      theme === 'dark' ? 'bg-gray-800' : 'bg-gray-200'
                    }`}
                  >
                    {children}
                  </pre>
                ),
              }}
            >
              {message}
            </ReactMarkdown>
          </div>
        ) : (
          <p className="text-xs sm:text-sm whitespace-pre-wrap break-words">{message}</p>
        )}
        {timestamp && (
          <p
            className={`text-[10px] sm:text-xs mt-1 ${
              isBot
                ? theme === 'dark'
                  ? 'text-gray-400'
                  : 'text-gray-500'
                : 'text-blue-100'
            }`}
          >
            {timestamp}
          </p>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;

